<template>
	<languages-switch :wrapper="wrapper">
		<a href="#" aria-expanded="false">
				<span uk-icon="icon: chevron-down; ratio: .8" class="uk-icon">
					<svg width="16"
						 height="16"
						 viewBox="0 0 20 20"
						 xmlns="http://www.w3.org/2000/svg"
						 data-svg="chevron-down">
						<polyline
							fill="none" stroke="#000" stroke-width="1.03"
							points="16 7 10 13 4 7">

						</polyline>
					</svg>
				</span>
			{{getLanguage(locale)}}
			<img class="img-responsive header_lang-preview" height="20px"
				 width="20px" alt=""
				 :src="require(`@/assets/img/flags/header_lang-${locale}.png`)">
		</a>
		<div ref='languageList' class="uk-navbar-dropdown switch-languages_left-menu uk-drop"
			 uk-drop="mode: click; boundary: .page">
			<ul class="uk-nav uk-navbar-dropdown-nav">
				<li><a @click.prevent="changeLocale('ee')">Estonian<img
					class="img-responsive header_lang" height="20px" width="20px"
					:src="require('@/assets/img/flags/header_lang-ee.png')" alt=""></a></li>
				<li><a @click.prevent="changeLocale('en')">English<img
					class="img-responsive header_lang" height="20px" width="20px"
					:src="require('@/assets/img/flags/header_lang-en.png')" alt=""></a></li>
				<li><a @click.prevent="changeLocale('lt')">Lithuanian<img
					class="img-responsive header_lang" height="20px" width="20px"
					:src="require('@/assets/img/flags/header_lang-lt.png')" alt=""></a></li>
				<li><a @click.prevent="changeLocale('lv')">Latvian<img
					class="img-responsive header_lang" height="20px" width="20px"
					:src="require('@/assets/img/flags/header_lang-lv.png')" alt=""></a></li>
				<li><a @click.prevent="changeLocale('ru')">Русский<img
					class="img-responsive header_lang" height="20px" width="20px"
					:src="require('@/assets/img/flags/header_lang-ru.png')" alt=""></a></li>
			</ul>
		</div>
	</languages-switch>
</template>

<script>
import store from '../../store'
import { LOCALE_SET } from 'actions/localization'
import LanguagesSwitch from 'components/languages-switch/LanguagesSwitch'

/** We can include jquery globally if needed */

export default {
	name: 'Languages',
	components: { LanguagesSwitch },
	computed: {
		locale: () => {
			return store.getters.getLocale
		}
	},
	props: {
		wrapper: {
			type: Boolean,
			default: true
		}
	},
	methods: {
		changeLocale: (locale) => {
			$('.switch-languages_left-menu').hide()
			store.dispatch(LOCALE_SET, locale)
		},
		getLanguage: (locale) => {
			switch (locale) {
				case 'en':
					return 'English'
				case 'ee':
					return 'Estonian'
				case 'lv':
					return 'Latvian'
				case 'ru':
					return 'Русский'
				case 'lt':
					return 'Lithuanian'
			}
		}
	}
}
</script>

<style scoped>

</style>
